module.exports = __webpack_public_path__ + "img/group122.8930033d.png";